module.exports = __webpack_public_path__ + "media/img/vogt-68441395b98ce1b965a53d2c24e3f55c.jpg";